import { createContext, useContext } from "react";

export type StorageSettingsMap = Record<string, string>;

export interface StorageSettingsContextValue {
  settings: StorageSettingsMap;
  ready: boolean;
  get: (key: string, fallback?: string) => string;
  setLocal: (key: string, value: string) => void;
  refresh: () => Promise<void>;
}

export const StorageSettingsContext = createContext<StorageSettingsContextValue | null>(null);

export function useStorageSettings(): StorageSettingsContextValue {
  const context = useContext(StorageSettingsContext);
  if (!context) {
    return {
      settings: {},
      ready: true,
      get: (_key, fallback = "") => fallback,
      setLocal: () => {},
      refresh: async () => {},
    };
  }
  return context;
}
